import * as React from "react";
import type { SVGProps } from "react";
const GroceryStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7610)">
      <path
        fill="currentColor"
        d="M1 2.9219C1 2.411 1.411 2 1.9219 2h1.7477c.8451 0 1.5941.4917 1.9437 1.2292h15.7874c1.0102 0 1.7477.9603 1.4827 1.936l-1.5749 5.8501c-.3265 1.2062-1.4213 2.0474-2.6697 2.0474H7.5569l.2075 1.0947c.0845.4341.4648.7491.9065.7491H19.745c.5109 0 .9219.411.9219.9219a.9196.9196 0 0 1-.9219.9218H8.6709c-1.329 0-2.4699-.9449-2.7157-2.2471L3.973 4.0935c-.0269-.146-.1537-.2497-.3035-.2497H1.922A.9197.9197 0 0 1 1 2.9218m4.9168 16.9013a1.844 1.844 0 0 1 2.5493-1.7034 1.843 1.843 0 0 1 .9979.9978 1.844 1.844 0 0 1-1.7035 2.5494 1.843 1.843 0 0 1-1.3037-.54 1.844 1.844 0 0 1-.54-1.3038m12.9064-1.8438a1.844 1.844 0 0 1 0 3.6876 1.8438 1.8438 0 0 1 0-3.6876"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_7610">
        <path fill="transparent" d="M1 2h22.1254v19.667H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default GroceryStore;
